import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './BlogPage.css';

const BlogPage = () => {
  // Sample blog posts data - you can replace this with your actual data
  const blogPosts = [
    {
      id: 1,
      title: 'Common Household Pests and How to Identify Them',
      excerpt: 'Learn about the most common household pests, their characteristics, and how to identify them early to prevent infestations.',
      date: 'Jan 14, 2025',
      category: 'Pest Identification',
      image: 'https://placehold.co/600x400/dc3545/white?text=Pest+Identification',
      slug: 'common-household-pests'
    },
    {
      id: 2,
      title: 'Natural Pest Control Methods for Your Garden',
      excerpt: 'Discover eco-friendly and natural methods to protect your garden from pests while maintaining a healthy environment.',
      date: 'Feb 12, 2025',
      category: 'Garden Care',
      image: 'https://placehold.co/600x400/dc3545/white?text=Garden+Care',
      slug: 'natural-pest-control'
    },
    {
      id: 3,
      title: 'Preventing Termite Infestations: A Complete Guide',
      excerpt: 'Everything you need to know about termite prevention, early detection, and protecting your property from these destructive pests.',
      date: 'March 10, 2025',
      category: 'Termite Control',
      image: 'https://placehold.co/600x400/dc3545/white?text=Termite+Guide',
      slug: 'termite-prevention'
    },
    {
      id: 4,
      title: 'Seasonal Pest Control: What to Watch For',
      excerpt: 'A seasonal guide to pest control, helping you prepare for and prevent pest problems throughout the year.',
      date: 'April 8, 2025',
      category: 'Seasonal Tips',
      image: 'https://placehold.co/600x400/dc3545/white?text=Seasonal+Guide',
      slug: 'seasonal-pest-control'
    }
  ];

  return (
    <div className="blog-page-container py-5">
      <div className="container">
        {/* Page Header */}
        <motion.div
          className="text-center mb-5"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="display-4 fw-bold page-title">Pest Control Blog</h1>
          <p className="lead text-muted">Expert insights, tips, and guides for effective pest management</p>
        </motion.div>

        {/* Blog Posts Grid */}
        <div className="row g-4">
          {blogPosts.map((post, index) => (
            <motion.div
              className="col-lg-6"
              key={post.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <article className="blog-card h-100">
                <div className="blog-card-image-container">
                  <img src={post.image} alt={post.title} className="blog-card-image" />
                  <div className="blog-card-category">{post.category}</div>
                </div>
                <div className="blog-card-content">
                  <div className="blog-card-meta">
                    <span className="blog-date">{post.date}</span>
                    <span className="blog-read-time">{post.readTime}</span>
                  </div>
                  <h2 className="blog-card-title">{post.title}</h2>
                  <p className="blog-card-excerpt">{post.excerpt}</p>
                  <Link  
                    className="btn btn-outline-danger read-more-btn"
                  >
                    Read More
                    <i className="bi bi-arrow-right ms-2"></i>
                  </Link>
                </div>
              </article>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogPage;
